import { Injectable, OnDestroy, OnInit } from '@angular/core';
import {
  BehaviorSubject,
  fromEvent,
  Observable,
  Subject,
  Subscription,
} from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LayoutService implements OnDestroy {
  private resize$ = new Subject<Event>();
  private resizeObservable$: Observable<Event>;
  private resizeSubscription: Subscription;

  initResize() {
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription = this.resizeObservable$
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((e) => {
        this.hasResized(e);
      });
  }

  onResize(): Observable<any> {
    return this.resize$.asObservable();
  }

  hasResized(e: Event) {
    this.resize$.next(e);
  }

  ngOnDestroy() {
    this.resizeSubscription.unsubscribe();
  }
}
